import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "YearTransition/";

const ValidateYearTransition = async (year) =>
    await axiosInstance.post(ENDPOINTORIGIN + 'ValidateYearTransition', { Year: year }, constants.REQUIRE_INTERCEPTORS);

const CreateAdminProposals = async (model) =>
    await axiosInstance.post(ENDPOINTORIGIN + 'CreateAdminProposals', model, constants.REQUIRE_INTERCEPTORS);

const GetAdminProposalsByYear = async (year) =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetAdminProposalsByYear/' + year, constants.REQUIRE_INTERCEPTORS);

const GetYearTransitionConfig = async () =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetYearTransitionConfig', constants.REQUIRE_INTERCEPTORS);

export {
    ValidateYearTransition,
    CreateAdminProposals,
    GetAdminProposalsByYear,
    GetYearTransitionConfig
};
